import React from "react";
import { Wrench, Sparkles } from "lucide-react";

export default function EmptyModule({ moduleName, icon: Icon = Wrench }) {
    return (
        <div
            data-testid="module-empty-state"
            className="mx-8 my-8 flex min-h-[60vh] flex-col items-center justify-center rounded-lg border border-dashed border-zinc-200 bg-white/60 bg-grid px-6 text-center"
        >
            <div className="flex h-10 w-10 items-center justify-center rounded-md border border-zinc-200 bg-white text-zinc-500 shadow-sm">
                <Icon className="h-4 w-4" strokeWidth={1.5} />
            </div>
            <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-zinc-900">
                {moduleName} is under development
            </h3>
            <p className="mt-2 max-w-md text-sm text-zinc-500 leading-relaxed">
                We are building this module with care. It will connect to the shared YugOS intelligence layer,
                so nothing here will feel bolted on.
            </p>
            <div className="mt-6 inline-flex items-center gap-1.5 rounded-full border border-blue-100 bg-blue-50 px-3 py-1 text-[11px] font-medium text-blue-700">
                <Sparkles className="h-3 w-3" strokeWidth={1.5} />
                Powered by Yug Brain (coming soon)
            </div>
        </div>
    );
}
